class TransitionManager {
  private srcCanvas: HTMLCanvasElement;
  private transitionElt: HTMLImageElement;

  constructor(elt: HTMLCanvasElement) {
    this.srcCanvas = elt;
  }

  initTransition() {
    if (this.transitionElt) {
      this.transitionElt.parentNode?.removeChild(this.transitionElt);
    }
    const image = new Image();
    this.transitionElt = image;
    image.src = this.srcCanvas.toDataURL();
    image.crossOrigin = "anonymous";
    image.style.zIndex = "1";
    image.style.height = this.srcCanvas.style.height;
    image.style.width = this.srcCanvas.style.width;
    image.style.transform = this.srcCanvas.style.transform;
    image.style.marginTop = this.srcCanvas.style.marginTop;
    image.style.marginLeft = this.srcCanvas.style.marginLeft;
    image.style.position = "absolute";
    this.srcCanvas.parentNode.prepend(image);
  }

  startTransition() {
    const image = this.transitionElt;
    if (!image) {
      return;
    }
    return new Promise((resolve, reject) => {
      requestAnimationFrame(() => {
        image.style.transition = "opacity 1s";
        image.style.opacity = "0";
        setTimeout(() => {
          image.parentNode?.removeChild(image);
          resolve(true);
        }, 1000);
      });
    });
  }
}

export { TransitionManager };
